import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Target, Globe, Brain, Shield } from 'lucide-react';

const Home = () => {
  return (
    <div className="page-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background">
          <img 
            src="https://images.unsplash.com/photo-1758518729706-b1810dd39cc6?w=1920&q=80"
            alt="Professional team collaboration"
            className="hero-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content">
          <h1 className="hero-title">BUILDING MEANING. AMPLIFYING IMPACT.</h1>
          <p className="hero-subtitle">
            Transforming fragmented messaging into clear, responsible, brand-centric narratives 
            that create meaningful audience experiences.
          </p>
          <div className="hero-buttons">
            <Link to="/services" className="btn-primary">
              Our Services <ArrowRight size={20} />
            </Link>
            <Link to="/contact" className="btn-secondary">
              Let's Talk
            </Link>
          </div>
        </div>
      </section>

      {/* Key Differentiators */}
      <section className="section-padding">
        <div className="container">
          <div className="text-center mb-96">
            <h2 className="heading-2">WHAT MAKES US DIFFERENT</h2>
            <p className="body-large max-w-3xl mx-auto">
              We bridge integration gaps across media, technology, communication, and strategy 
              to deliver future-ready solutions with ethical practice at our core.
            </p>
          </div>

          <div className="differentiators-grid">
            <div className="differentiator-card">
              <div className="differentiator-icon">
                <Target size={32} />
              </div>
              <h3 className="heading-5">Bridging the Communication Gap</h3>
              <p className="body-small">
                Transforming fragmented messaging into clear, responsible, and brand-centric 
                narratives that resonate with your audience.
              </p>
            </div>

            <div className="differentiator-card">
              <div className="differentiator-icon">
                <Globe size={32} />
              </div>
              <h3 className="heading-5">Cutting Through Digital Noise</h3>
              <p className="body-small">
                Building distinct brand identities that earn attention and command respect 
                in crowded digital landscapes.
              </p>
            </div>

            <div className="differentiator-card">
              <div className="differentiator-icon">
                <Shield size={32} />
              </div>
              <h3 className="heading-5">Ethical & Compliant Delivery</h3>
              <p className="body-small">
                Operating within regulatory frameworks with integrity and industry responsibility 
                in every project we undertake.
              </p>
            </div>

            <div className="differentiator-card">
              <div className="differentiator-icon">
                <Brain size={32} />
              </div>
              <h3 className="heading-5">Future-Ready Approach</h3>
              <p className="body-small">
                Adapting to evolving technologies and communication pathways with responsible 
                AI integration and digital strength.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Statement */}
      <section className="vision-section">
        <div className="container">
          <div className="vision-content">
            <h2 className="heading-3">OUR VISION</h2>
            <p className="body-large vision-text">
              To build ecosystems that combine <strong>Media Precision</strong> + 
              <strong> Human Relevance</strong> + <strong>Cultural Intelligence</strong> + 
              <strong> Ethical Practice</strong> + <strong>Digital Strength</strong> + 
              <strong> Responsible AI</strong>
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="heading-2">READY TO AMPLIFY YOUR IMPACT?</h2>
            <p className="body-large">
              Let's transform your communication strategy and build meaningful connections 
              with your audience.
            </p>
            <Link to="/contact" className="btn-primary btn-large">
              Start Your Project <ArrowRight size={24} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
